/*  using singleton pattern to retain instance when 
    switching / composing with other modules */
define('editor/edit/layers/list/index',['utils', 'jquery', 'durandal/app', 'plugins/http', 'plugins/dialog', 'knockout', 'knockout-mapping', 'jqueryui'], function (utils, $, app, http, dialog, ko, komapping) {
    return {
        editorMapId: null,
        controls: ko.observableArray([]),
        markers: ko.observableArray([]),
        vectors: ko.observableArray([]),
        overlays: ko.observableArray([]),
        boundaries: ko.observableArray([]),

        eventHandlersRegistered: false,

        // lifecycle
        activate: function(editorMap, editLayerHandler, editGroupLayerHandler) {
            this.editorMapId = editorMap.id;
            this.readOnly = editorMap.readOnly;
            this.editLayerHandler = editLayerHandler;
            this.editGroupLayerHandler = editGroupLayerHandler;

            if (!this.eventHandlersRegistered) {
                this.registerEventHandlers();
            }
        },

        compositionComplete: function () {
            this.refresh();
            
            // wire up "multiselect"
            $('.sortable').on('click', 'li', function(e) { 
                var isAlreadySelected = $(this).hasClass("selected"),
                    layer = ko.dataFor($(this).get(0)),
                    thisSortable = $(this).parent();

                // cannot multi-select layers from different sections
                $('.sortable').each(function () {
                    if ($(this).get(0) !== thisSortable.get(0)) {
                        $('.selected', $(this)).removeClass('selected');
                    }
                });

                if (layer.isGroup() || !utils.isEmptyGuid(layer.groupId())) {
                    return;
                }

                if (e.ctrlKey || e.metaKey || isAlreadySelected) {
                    $(this).toggleClass("selected");
                } else {
                    $(this).addClass("selected").siblings().removeClass('selected');
                }
            });
        },

      layerListItemMouseOver: function (layer) {
        var id = layer.id();

        app.trigger('layer:item-selected', id);
      },

      layerListItemMouseOut: function (layer) {
        var id = layer.id();

        app.trigger('layer:item-deselected', id);
      },

        initSortables: function () {
            var self = this,
                options = {
                    connectWith: '', 
                    placeholder: "dd-placeholder",
                    zIndex: 9999,
                    opacity: 0.5,
                    axis: 'y',
                    stop: function (evt, element) {
                        var movedIntoGroup = element.item.parent().is('.layer-group');
                        var isGroup = $('.layer-group', element.item).length;

                        if (isGroup && movedIntoGroup) {
                            // can't have nested groups
                            $(this).sortable("cancel");

                            return;
                        }
                        
                        // marker layers moved into an autonumbered group need to inherit the properties of the other layers in the group (i.e icon style)
                        if (movedIntoGroup) {
                            var layerForElement = ko.dataFor(element.item.get(0));
                            var group = ko.dataFor(element.item.parent().get(0));
                            var autoNumberLayer = ko.utils.arrayFirst(group.layers(), function(item) {
                                return item.state().isAutoNumber && item.state().isAutoNumber();
                            });

                            if (layerForElement.type() === "Marker" && autoNumberLayer) {
                                layerForElement.state().isAutoNumber = ko.observable(true);
                                layerForElement.state().selectedicon(autoNumberLayer.state().selectedicon());

                                self.saveLayer(layerForElement).then(function() {
                                    self.layerReorderCommand();
                                });
                            } else {
                                self.layerReorderCommand();
                            }
                        } else {
                            self.layerReorderCommand();
                        }
                    }
                };

            // have to init each list individually to leverage use of 'connectWith' property, so we can add/remove from the nested groups
            options.connectWith = "#extras-list ol"; // restrict drag/drop to this list only
            $("#extras-list ol").sortable(options);
            options.connectWith = "#markers-list ol"; // restrict drag/drop to this list only
            $("#markers-list ol").sortable(options);
            options.connectWith = "#boundaries-list ol"; // restrict drag/drop to this list only
            $("#boundaries-list ol").sortable(options);
            options.connectWith = "#shapes-list ol"; // restrict drag/drop to this list only
            $("#shapes-list ol").sortable(options);
        },

        registerEventHandlers: function () {
            var self = this;

            app.on('layer:new', self.processNewLayer.bind(self));
            app.on('layer:delete', self.deleteLayer.bind(self));
            app.on('layer:group:create', self.createNewGroupFromSelectedLayers.bind(self));
            app.on('layers:available', self.refresh.bind(self));            
            self.eventHandlersRegistered = true;
        },
        
        processNewLayer: function (layer) {
            var self = this,
                isMarkerLayer = layer.type() === "Marker";

            var await = self.refresh();

            if (isMarkerLayer) {
                await.then(function () {
                    self.editLayerCommand(layer);
                });
            }
        },
        
        refresh: function () {
            var self = this,
                layersUrl = "/api/editor/layers",
                data = {
                    editorMapId: self.editorMapId
                };

            return http.get(layersUrl, data)
                .then(function (response) {
                    if (response.data) {
                        self.clearLayers();
                        
                        var responseLayersLen = response.data.layers.length,
                            layers = ko.observableArray([]),
                            group;

                        for (var i = 0; i < responseLayersLen; i++) {
                            var layerData = response.data.layers[i],
                                isGroupLayer = layerData.hasOwnProperty('groupName'),
                                isNewGroup = isGroupLayer && (!group || group.layers()[0].groupId() !== layerData.groupId),
                                layer = self.makeLayer(layerData),
                                section = self.getSectionForLayer(layer);

                            layers.push(layer);

                            if (isGroupLayer) {
                                if (isNewGroup) {
                                    group = self.makeGroup(layerData.groupId, layerData.groupName, layerData.groupColour, layerData.groupCollapsed);
                                    section.push(group);
                                }

                                layer.group = group;
                                group.layers.push(layer);
                            } else {
                                section.push(layer);
                            }
                        }

                        // we're done, publish the original layer data so other things can do something with it
                        app.trigger('layers:newData', layers);

                        self.initSortables();
                    }
                }).fail(self.showFetchLayersFail);
        },
        
        createNewGroupFromSelectedLayers: function () {
            // if adding sequential layers to a group, then order doesn't change
            // but if adding from non-sequential layers, the API will re-order them based on index of first layer in new group
            var self = this,
                selectedLayers = $('.selected', $('.sortable')),
                selectedLayersLen = selectedLayers.length,
                url = "/api/editor/layers/group/new",
                data = {
                    editorMapId: self.editorMapId,
                    layerIds: []
                };

            if (selectedLayersLen === 0) {
                return app.showMessage("Click on a layer in the list to select it. <br/><br/>You can hold down the Ctrl key to select multiple layers.", "No Layers Selected");
            }

            for (var i = 0; i < selectedLayersLen; i++) {
                var layer = ko.dataFor($(selectedLayers[i]).get(0)),
                    layerId = layer.id();

                data.layerIds.push(layerId);
            }

            return http.post(url, data)
                .fail(app.showError)
                .then(function () {
                    self.refresh();
                });
        },

        // messages
        showFetchLayersFail: function () {
            dialog.showMessage("Unable to retrieve map layers", "Unexpected Error");
        },

        // UI commands
        toggleLayerVisibilityCommand: function (layer, e) {
            var self = this;

            e.stopPropagation();

            if (layer.isGroup()) {
                self.toggleGroupLayerVisibility(layer)
                    .then(function () {
                        self.refresh();
                    });
            } else {
                layer.visible(!layer.visible());
                self.saveLayer(layer)
                    .then(function () {
                        app.trigger("layer:visibility", layer);
                    });
            }
        },

        editLayerCommand: function (layer, e) {
            var self = this;

            if (e && e.stopPropagation) {
                e.stopPropagation();
            }
            
            if (layer.isGroup()) {
                self.editGroupLayerHandler(layer, layer.layers());
            } else {
                self.editLayerHandler(layer);
            }
        },

        deleteLayerCommand: function (layer, e) {
            var self = this;
            
            e.stopPropagation();

            if (window.confirm("Are you sure you want to delete this layer? The action cannot be undone.")) {
                if (layer.isGroup()) {
                    self.deleteGroupLayer(layer);
                } else {
                    // when changing auto numbered marker groups, the layers need to be refreshed on the map 
                    // otherwise the icon number doesn't match up with the number in the list view
                    var needsRefresh = (layer.state().isAutoNumber && layer.state().isAutoNumber());

                    self.deleteLayer(layer, needsRefresh);
                }
            }
        },
        
        layerReorderCommand: function () {
            var self = this,
                serialized = self.serialiseLayers();

            self.saveSerializedLayers(serialized);
        },
        
        toggleCollapseGroup: function (layer, e) {
            e.stopPropagation();
            
            var self = this,
                groupListItem = $(e.target).closest('li'),
                groupLayer = ko.dataFor(groupListItem.get(0));

            groupLayer.isCollapsed(!groupLayer.isCollapsed());
            
            var url = '/api/editor/layers/group/details',
                data = {
                    editorMapId: self.editorMapId,
                    groupId: groupLayer.id(),
                    groupCollapsed: groupLayer.isCollapsed(),
                    groupName: groupLayer.name()
                };

            return http.post(url, data)
                .fail(app.showError);
        },
       
        // API
        saveLayer: function (layer) {
            var url = "/api/editor/layers",
                data = {
                    editorMapId: this.editorMapId,
                    layerId: layer.id(),
                    order: layer.order(),
                    name: layer.name(),
                    visible: layer.visible(),
                    state: layer.state()
                };

            return http.post(url, data)
                .then(function (response) {
                    if (!response.success) {
                        app.showMessage(response.error, "Couldn't save layer");
                    }
                }).fail(app.showError);
        },
        
        deleteLayer: function (layer, withRefresh) {
            var self = this,
                url = "/api/editor/layers/delete",
                data = {
                    editorMapId: self.editorMapId,
                    layerId: layer.id()
                };

            return http.post(url, data)
                .then(function (response) {
                    if (response.success) {
                        if (withRefresh) {
                            self.refresh();
                        } else {
                            app.trigger("layers:deleted", [layer]);
                            self.removeLayerFromListView(layer);
                        }
                    }
                }).fail(app.showError);
        },

        removeLayerFromListView: function(layer) {
            var self = this,
                section = self.getSectionForLayer(layer);

            if (layer.group) {
                var group = layer.group;

                group.layers.remove(layer);

                // group is empty, remove it too
                if (group.layers().length < 1) {
                    section.remove(group);
                }
            }
            else {
                section.remove(layer);
            }
        },
        
        deleteGroupLayer: function (group) {
            var self = this;
            var layersToDelete = group.layers();
            var section;
            var url = "/api/editor/layers/group/delete";
            var data = {
                editorMapId: self.editorMapId,
                layerGroupId: group.id()
            };

            section = self.getSectionForLayer(layersToDelete[0]);

            return http.post(url, data)
                .then(function (response) {
                    if (response.success) {
                        app.trigger("layers:deleted", layersToDelete);
                        section.remove(group);
                        section.removeAll(layersToDelete);
                    }
                }).fail(app.showError);
        },
        
        toggleGroupLayerVisibility: function (group) {
            var self = this,
                url = "/api/editor/layers/group/visibility",
                data = {
                    editorMapId: self.editorMapId,
                    groupId: group.id(),
                    isVisible: !group.visible()
                };

            return http.post(url, data)
                .fail(app.showError);
        },
        
        saveSerializedLayers: function (serialized) {
            var self = this,
                url = "/api/editor/layers/sync",
                data = {
                    editorMapId: self.editorMapId,
                    layers: serialized
                };
            
            return http.post(url, data)
                .then(function () {
                    self.refresh();
                })
                .fail(app.showError);
        },

        // helpers
        hasLayers: function () {
            var self = this;

            return self.controls().length > 0 ||
                self.boundaries().length > 0 ||
                self.markers().length > 0 ||
                self.vectors().length > 0 ||
                self.overlays().length > 0;
        },
        
        getSectionForLayer: function (layer) {
            var self = this,
                type = layer.type(),
                sectionName = utils.getSectionNameForLayerType(type);

            return self[sectionName];
        },

        clearLayers: function () {
            var self = this;
            
            self.controls.removeAll();
            self.markers.removeAll();
            self.vectors.removeAll();
            self.overlays.removeAll();
            self.boundaries.removeAll();
        },

        makeLayer: function (data) {
            var layer = {};
            if (data.state.html) {
                data.state.html = String(data.state.html);
            }

            var state = data.state;

            if (data.type !== 'Directions') {
                state = komapping.fromJS(data.state);
                delete state['__ko_mapping__'];
            }

            layer.id = ko.observable(data.id);
            layer.groupId = ko.observable(data.groupId);
            layer.groupName = ko.observable(data.groupName);
            layer.groupColour = ko.observable(data.groupColour);
            layer.groupCollapsed = ko.observable(data.groupCollapsed);
            layer.name = ko.observable(data.name);
            layer.visible = ko.observable(data.visible);
            layer.type = ko.observable(data.type);
            layer.order = ko.observable(data.order);
            layer.state = ko.observable(state);
            layer.typeIcon = this.makeIcon(data);
            layer.isGroup = ko.observable(false);
            layer.labelOrName = ko.observable(data.state && data.state.html && data.state.html.length > 0 ? data.state.html : data.name);

            return layer;
        },
        
        makeGroup: function (id, name, colour, collapsed) {
            var group = {
                id: ko.observable(id),
                name: ko.observable(name),
                groupColour: ko.observable(colour),
                isGroup: ko.observable(true),
                layers: ko.observableArray([]),
                isCollapsed: ko.observable(collapsed)
            };
            
            group.isExpanded = ko.computed(function () {
                return !group.isCollapsed();
            });

            group.typeIcon = ko.computed(function () {
                if (group.layers().length && group.layers()[0].type() === 'Marker') {
                    var isAutoNumbered = group.layers()[0].state().isAutoNumber ? group.layers()[0].state().isAutoNumber() : false;
                    if (isAutoNumbered) {
                        return 'fa fa-list-ol';
                    }
                }
                return group.isCollapsed() ? "fa fa-folder" : "fa fa-folder-open";
            });

            // a group is visible when at least 1 child layer is visible
            group.visible = ko.computed(function() {
                var visible = false;

                ko.utils.arrayForEach(group.layers(), function (layer) {
                    visible = visible || layer.visible();
                });

                return visible;
            });

            group.getAutoNumberedIndexForLayer = function (layer) {
                var groupLayersExcludingDirections = ko.utils.arrayFilter(this.layers(), function (item) {
                    return item.type() !== "Directions";
                });

                return groupLayersExcludingDirections.indexOf(layer) + 1;
            };

            return group;
        },
        
        makeIcon: function (data) {
            return ko.computed(function () {
                var icon = "fa ",
                    type = data ? data.type : '';

                if (type === 'MiniMap') {
                    icon += "fa-picture-o";
                } else if (type === 'ScaleBar') {
                    icon += "fa-info-circle";
                } else if (type === 'TextBlock') {
                    icon += "fa-font";
                } else if (type === 'Polyline') {
                    icon += "polyline";
                } else if (type === 'Polygon') {
                    icon += "polygon";
                } else if (type === 'Rectangle') {
                    icon += "rectangle";
                } else if (type === 'Circle') {
                    icon += "circle";
                } else if (type === 'Marker') {
                    icon += "marker";
                } else if (type === 'Directions') {
                    icon += "fa-location-arrow";
                } else if (type === 'GeoJSON') {
                    icon += "fa-puzzle-piece";
                } else if (type === 'KML') {
                    icon += "fa-puzzle-piece";
                } else if (type === 'Boundary') {
                    icon += "fa-globe";
                } else if (type === 'Legend') {
                    icon += "fa-list";
                } else if (type === 'Overlay') {
                    icon += "fa-list";
                } else { // layer group
                    icon += "fa-folder-open";
                }

                return icon;
            });
        },
       
        serialiseLayers: function () {
            var flattened = [],
                order = 0,
                listItems = $('.layer-list li'), // get a flattened array of <li>s
                listItemsLen = listItems.length,
                listItem,
                layer,
                listItemParent;

            for (var i = 0; i < listItemsLen; i++) {
                listItem = listItems[i];
                layer = ko.dataFor(listItem);
                listItemParent = $(listItem).parent('ol').parent('li');
                
                if (layer.isGroup && !layer.isGroup()) {
                    var data = {
                        layerId: layer.id()
                    };
                    
                    if (listItemParent.length) {
                        data['groupid'] = listItemParent.attr('data-id');
                    }

                    flattened.push(data);
                }
            }

            for (var j = 0; j < flattened.length; j++) {
                flattened[j]['order'] = order;
                order++;
            }

            return flattened;
        }
    };
});

